import React, { useState } from "react";
import Contact from "../contact";
import Testimonials from "../Testimonials";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import permanentIcon from "../../images/individual/permanent-resident.svg";
import visaImage from "../../images/individual/visa-assistance-image.png";
import helpIcon from "../../images/individual/helpIcon.svg";
import helpImage from "../../images/individual/immigetHelp.png";
import { FaPlus, FaTimes, FaCheckCircle, FaClock, FaGavel, FaFileAlt, FaShieldAlt, FaUsers, FaBalanceScale, FaExclamationTriangle, FaLanguage, FaDollarSign, FaTrophy, FaCalendarAlt, FaUserTie, FaClipboardCheck, FaHandshake } from "react-icons/fa";
import unlimitedIcon from "../../images/individual/ic_outline-home-work.svg";
import iconPeople from "../../images/individual/akar-icons_people-group.svg";
import materialIcon from "../../images/individual/material-symbols_family-home-outline.svg";
import applicationProcess from "../../images/individual/application-proccess.svg";
import { Helmet } from "react-helmet-async";

const AATReview = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Testimonials data for this specific page
  const testimonials = [
    {
      content: "My partner visa was refused but Immiget Global won our AAT appeal in just 14 months!",
      name: "Jessica & Tom",
      location: "Australia",
      visaType: "Partner Visa AAT Appeal"
    },
    {
      content: "Thanks to their skilled visa appeal strategy, I now have my PR!",
      name: "Arjun",
      location: "India",
      visaType: "Skilled Visa AAT Appeal"
    }
  ];

  const faqs = [
    {
      question: "Can I stay in Australia during appeal?",
      answer: "Yes, if you hold or are granted a bridging visa."
    },
    {
      question: "What if I miss the deadline?",
      answer: "Options become extremely limited - act now!"
    },
    {
      question: "How long until my hearing?",
      answer: "Typically 12-18 months after lodging."
    },
    {
      question: "Can I submit new evidence?",
      answer: "Yes, this is often crucial to success."
    }
  ];

  return (
    <div>
      <Helmet>
        <title>AAT Review Australia - Administrative Appeals Tribunal - Immiget Global</title>
        <meta
          name="description"
          content="Visa refused or cancelled? Win your AAT appeal with 85% success rate. Expert migration lawyers for Administrative Appeals Tribunal cases. Free case assessment."
        />
        <meta 
          name="keywords" 
          content="AAT review, administrative appeals tribunal, visa refusal appeal, visa cancellation appeal, migration appeal, AAT hearing" 
        />
      </Helmet>
      
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <div className="text-white hellix-font text-center font-semibold text-[22px] md:text-[54px]">
              AAT Review
            </div>
            <div className="flex justify-center gap-2 md:gap-4">
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Appeals & Waivers
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                AAT Review
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="xl:flex gap-4 justify-center container max-w-1440px mx-auto px-4 py-4 md:py-10 lg:px-14">
        <div className="xl:w-[50%]">
          <h1 className="xl:text-[30px] max-xl:text-center text-blue mt-6 font-semibold hellix-font">
            AAT Review (Administrative Appeals Tribunal) – Appeal Your Visa Refusal or Cancellation
          </h1>
          <p className="max-xl:text-center hellix-font text-blue xl:text-[18px] font-normal">
            Had your Australian visa refused or cancelled? The Administrative Appeals Tribunal (AAT) gives you a second chance to challenge the decision. At Immiget Global, our migration experts specialize in winning AAT cases with an 85% success rate for properly prepared appeals.
          </p>
        </div>
        <div className="xl:w-[50%] max-xl:justify-center max-xl:flex max-xl:mt-4">
          <img src={visaImage} alt="AAT Review" />
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* What is the AAT Review Process */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="text-2xl text-blue font-semibold hellix-font">
            What is the AAT Review Process?
          </h1>
        </div>
        <div className="text-blue font-normal text-lg mt-2 hellix-font">
          The AAT is an independent body that reviews:
        </div>
        
        <div className="flex flex-wrap justify-between mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaCheckCircle className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-xl font-normal text-center hellix-font px-4">
              Visa refusals (student, partner, skilled, parent visas)
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaShieldAlt className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-xl font-normal text-center hellix-font px-4">
              Visa cancellations
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaHandshake className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-xl font-normal text-center hellix-font px-4">
              Sponsorship refusals
            </div>
          </div>
        </div>
        <div className="flex gap-8 justify-center flex-wrap mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaUserTie className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-xl font-normal max-md:px-2 text-center hellix-font">
              Citizenship refusals
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Key Facts About AAT Appeals */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="text-2xl text-blue font-semibold hellix-font">
            Key Facts About AAT Appeals
          </h1>
        </div>
        <div className="lg:ml-4 mt-4">
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg font-normal hellix-font">
              <strong>Must lodge within strict deadlines</strong> (usually 21 days)
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg font-normal hellix-font">
              <strong>No automatic stay on removal</strong> (unless you have a bridging visa)
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg font-normal hellix-font">
              <strong>New evidence can be submitted</strong>
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg font-normal hellix-font">
              <strong>50-70% success rate</strong> for well-prepared cases
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Our AAT Appeal Success Process */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={applicationProcess} alt="Application Process" />
          </div>
          <h1 className="text-2xl text-blue font-semibold hellix-font">
            Our AAT Appeal Success Process
          </h1>
        </div>
        
        <div className="mt-6 space-y-6">
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">1</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Free Case Assessment
              </h3>
            </div>
            <div className="ml-16">
              <p className="text-blue hellix-font mb-3">We analyze your refusal letter to determine:</p>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue rounded-full"></span>
                  <span className="text-blue hellix-font">Grounds for appeal</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue rounded-full"></span>
                  <span className="text-blue hellix-font">Chances of success</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue rounded-full"></span>
                  <span className="text-blue hellix-font">Best legal strategy</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">2</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Document Preparation
              </h3>
            </div>
            <div className="ml-16">
              <p className="text-blue hellix-font mb-3">We help gather:</p>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue rounded-full"></span>
                  <span className="text-blue hellix-font">New supporting evidence</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue rounded-full"></span>
                  <span className="text-blue hellix-font">Expert reports (medical, relationship, employment)</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue rounded-full"></span>
                  <span className="text-blue hellix-font">Statutory declarations</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">3</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Legal Submission
              </h3>
            </div>
            <div className="ml-16">
              <p className="text-blue hellix-font mb-3">Our registered agents:</p>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <FaCheckCircle className="text-green-500 text-sm" />
                  <span className="text-blue hellix-font">Draft persuasive legal arguments</span>
                </div>
                <div className="flex items-center gap-2">
                  <FaCheckCircle className="text-green-500 text-sm" />
                  <span className="text-blue hellix-font">Address all refusal points</span>
                </div>
                <div className="flex items-center gap-2">
                  <FaCheckCircle className="text-green-500 text-sm" />
                  <span className="text-blue hellix-font">Submit professionally prepared bundles</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">4</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Hearing Preparation
              </h3>
            </div>
            <div className="ml-16">
              <p className="text-blue hellix-font mb-3">We provide:</p>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue rounded-full"></span>
                  <span className="text-blue hellix-font">Mock hearings</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue rounded-full"></span>
                  <span className="text-blue hellix-font">Witness preparation</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue rounded-full"></span>
                  <span className="text-blue hellix-font">Submission coaching</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">5</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Representation at Hearing
              </h3>
            </div>
            <div className="ml-16">
              <p className="text-blue hellix-font mb-3">Our experienced advocates:</p>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue rounded-full"></span>
                  <span className="text-blue hellix-font">Present your case effectively</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue rounded-full"></span>
                  <span className="text-blue hellix-font">Cross-examine witnesses</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue rounded-full"></span>
                  <span className="text-blue hellix-font">Make closing submissions</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Why Choose Immiget Global */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="text-2xl text-blue font-semibold hellix-font">
            Why Choose Immiget Global for Your AAT Appeal?
          </h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaTrophy className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-xl text-center max-md:px-2 font-normal hellix-font">
              🔹 85% Success Rate - Far above industry average
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaShieldAlt className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-xl text-center max-md:px-2 font-normal hellix-font">
              🔹 Former Immigration Officers on our team
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaClock className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-xl text-center max-md:px-2 font-normal hellix-font">
              🔹 Fast Turnaround - Meet tight deadlines
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaDollarSign className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-xl text-center max-md:px-2 font-normal hellix-font">
              🔹 Fixed Fees - No hidden costs
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaLanguage className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-xl text-center max-md:px-2 font-normal hellix-font">
              🔹 Multilingual Support - Available in 8 languages
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Common AAT Appeal Scenarios */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="text-2xl text-blue font-semibold hellix-font">
            Common AAT Appeal Scenarios We Handle
          </h1>
        </div>
        
        <div className="mt-8 overflow-x-auto">
          <table className="w-full bg-white shadow-custom-white rounded-lg overflow-hidden">
            <thead className="bg-blue text-white">
              <tr>
                <th className="p-4 text-left hellix-font font-semibold">Visa Type</th>
                <th className="p-4 text-left hellix-font font-semibold">Success Rate</th>
                <th className="p-4 text-left hellix-font font-semibold">Key Factors</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-200">
                <td className="p-4 text-blue font-semibold hellix-font">Partner Visa</td>
                <td className="p-4 text-blue hellix-font">82%</td>
                <td className="p-4 text-blue hellix-font">Proving genuine relationship</td>
              </tr>
              <tr className="border-b border-gray-200 bg-gray-50">
                <td className="p-4 text-blue font-semibold hellix-font">Student Visa</td>
                <td className="p-4 text-blue hellix-font">78%</td>
                <td className="p-4 text-blue hellix-font">Addressing GTE concerns</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="p-4 text-blue font-semibold hellix-font">Skilled Visa</td>
                <td className="p-4 text-blue hellix-font">75%</td>
                <td className="p-4 text-blue hellix-font">Correcting points calculation</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="p-4 text-blue font-semibold hellix-font">Visitor Visa</td>
                <td className="p-4 text-blue hellix-font">65%</td>
                <td className="p-4 text-blue hellix-font">Demonstrating compliance intent</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* AAT Processing Times & Fees */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="text-2xl text-blue font-semibold hellix-font">
            AAT Processing Times & Fees
          </h1>
        </div>

        <div className="mt-8 bg-white shadow-custom-white rounded-lg p-6">
          <h3 className="text-blue text-2xl font-semibold hellix-font mb-4 flex items-center gap-3">
            <FaCalendarAlt className="text-blue" />
            Current Wait Times:
          </h3>
          <div className="space-y-4">
            <div className="flex items-start gap-3 p-4 bg-blue-50 rounded-lg">
              <span className="w-2 h-2 bg-blue rounded-full mt-2"></span>
              <span className="text-blue text-lg hellix-font">12-18 months for most visa categories</span>
            </div>
            <div className="flex items-start gap-3 p-4 bg-green-50 rounded-lg">
              <span className="w-2 h-2 bg-green-500 rounded-full mt-2"></span>
              <span className="text-blue text-lg hellix-font">6-9 months for urgent cases (requestable)</span>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Critical Timeframes Warning */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="bg-red-50 rounded-lg p-8">
          <div className="flex gap-4 items-start">
            <FaExclamationTriangle className="text-red-500 text-3xl flex-shrink-0 mt-1" />
            <div>
              <h2 className="text-2xl text-blue font-bold hellix-font mb-4">
                Don't Miss Your Appeal Deadline!
              </h2>
              <h3 className="text-blue text-xl font-semibold hellix-font mb-4">
                ⚠ Critical Timeframes:
              </h3>
              <div className="space-y-3">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-red-500 rounded-full"></span>
                  <span className="text-blue text-lg hellix-font">21 days for most visa refusals</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-red-500 rounded-full"></span>
                  <span className="text-blue text-lg hellix-font">7 days for some cancellations</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-red-500 rounded-full"></span>
                  <span className="text-blue text-lg hellix-font">9 days for protection visas</span>
                </div>
              </div>
              <div className="flex gap-4 mt-6">
                <button 
                  onClick={scrollToContact}
                  className="px-6 py-3 bg-red-500 text-white font-semibold hellix-font rounded-lg hover:bg-red-600 transition-colors"
                >
                  Get Immediate Help
                </button>
                <button 
                  onClick={scrollToContact}
                  className="px-6 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors"
                >
                  Check Appeal Deadline
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* FAQ Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <h1 className="text-2xl text-center text-blue font-semibold hellix-font">
          AAT Appeal FAQs
        </h1>
        <p className="text-blue font-normal text-xl text-center hellix-font">
          Get answers to common questions about AAT appeals.
        </p>

        <div className="accordion-container mt-8">
          {faqs.map((faq, index) => (
            <div key={index} className="accordion mt-2">
              <div
                className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
                onClick={() => toggleAccordion(index)}
              >
                <h2 className="md:text-xl text-lg text-blue font-medium hellix-font">
                  ❓ {faq.question}
                </h2>
                {activeIndex === index ? <FaTimes /> : <FaPlus />}
              </div>
              {activeIndex === index && (
                <div className="accordion-content p-4">
                  <p className="text-[#667d87] md:text-xl text-lg font-normal hellix-font">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Testimonials Section */}
      <Testimonials 
        testimonials={testimonials} 
        title="Recent AAT Success Stories"
      />

      {/* CTA Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-lg p-8 text-center">
          <h2 className="text-3xl text-blue font-bold hellix-font mb-4">
            Take Action Now!
          </h2>
          <p className="text-blue text-lg hellix-font mb-6">
            Every day counts after a refusal. Let our experts assess your case immediately.
          </p>
          <button 
            onClick={scrollToContact}
            className="px-8 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors"
          >
            Get Free Case Assessment
          </button>
        </div>
      </div>

      {/* How We Help Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex max-lg:flex-col justify-between gap-6 lg:gap-[80px] lg:items-center">
          <div className="lg:w-[50%]">
            <div className="flex gap-2">
              <div className="flex items-center">
                <img src={helpIcon} alt="help" />
              </div>
              <h1 className="text-[26px] text-blue font-semibold hellix-font">
                How Immiget Global Can Help
              </h1>
            </div>
            <p className="hellix-font text-blue text-lg font-normal mt-4">
              Our experienced AAT specialists understand the complexity of appeal processes and have a proven track record of overturning refusal decisions. We provide comprehensive support from initial case assessment through to hearing representation, ensuring every aspect of your appeal is professionally managed and strategically positioned for success.
            </p>
            <div className="flex gap-4 mt-6">
              <button 
                onClick={scrollToContact}
                className="px-6 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors"
              >
                Contact Us Today
              </button>
            </div>
          </div>
          <div className="lg:w-[50%] max-lg:justify-center max-lg:flex">
            <img src={helpImage} alt="How we can help" />
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div id="contact-section">
        <Contact />
      </div>
    </div>
  );
};

export default AATReview;